var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 32 4 L 32 8 L 32 10 L 34 10 L 34 8 L 38 8 L 38 4 L 32 4 z M 34 10 L 34 17.28125 C 34.596 17.62825 35 18.261 35 19 C 35 20.104 34.104 21 33 21 C 31.896 21 31 20.104 31 19 C 31 18.262 31.404 17.62825 32 17.28125 L 32 10 L 22.3125 10 C 25.1465 11.992 27 15.28 27 19 L 27 36 L 47 36 C 47.553 36 48 35.553 48 35 L 48 19 C 48 14.038 43.963 10 39 10 L 34 10 z M 16.5 10.03125 C 11.771 10.29325 8 14.207 8 19 L 8 35 C 8 35.553 8.448 36 9 36 L 25 36 L 25 19 C 25 14.207 21.229 10.29325 16.5 10.03125 z M 14 20 L 19 20 C 19.552 20 20 20.448 20 21 C 20 21.552 19.552 22 19 22 L 14 22 C 13.448 22 13 21.552 13 21 C 13 20.448 13.448 20 14 20 z M 28 38 L 28 46 L 34 46 L 34 38 L 28 38 z",
    fill: "#B6BEC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOrder);
export default __webpack_public_path__ + "static/media/mail-order.4df28f5df9dcc083a5168086f0daec28.svg";
export { ForwardRef as ReactComponent };